export enum PairCompatibilityStatus {    
    Unknown = -1,
    Incompatible = 0,
    Compatible = 1
}